import { render, staticRenderFns } from "./myinfo-fullname.vue?vue&type=template&id=59569e88&"
import script from "./myinfo-fullname.vue?vue&type=script&lang=js&"
export * from "./myinfo-fullname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports